var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Grid from '@mui/material/Grid';
import { motion } from 'framer-motion';
import Responsive from 'react-responsive';
import get from "lodash/get";
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
import SingleImageSelectCard from './SingleImageSelectCard';
import { withConditionals } from '../../utilities/hoc/conditionals';
var ImageOptions = function (props) {
    var avatarOnTopLayout = props.avatarOnTopLayout, cardStyles = props.cardStyles, _a = props.flexDirection, flexDirection = _a === void 0 ? 'row' : _a, gridConfiguration = props.gridConfiguration, isSelected = props.isSelected, _b = props.mobileOptions, mobileOptions = _b === void 0 ? [] : _b, onClick = props.onClick, _c = props.options, options = _c === void 0 ? [] : _c, _d = props.questionKey, questionKey = _d === void 0 ? "" : _d, _e = props.forceUseCustomGrid, forceUseCustomGrid = _e === void 0 ? false : _e, singleImageSelectCardProps = __rest(props, ["avatarOnTopLayout", "cardStyles", "flexDirection", "gridConfiguration", "isSelected", "mobileOptions", "onClick", "options", "questionKey", "forceUseCustomGrid"]);
    var container = {
        hidden: {
            opacity: 0,
            transition: { duration: 0.15 },
        },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                y: { type: 'spring', stiffness: 1000, damping: 15 },
                duration: 0.2,
            },
        },
    };
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    function getDefaultItemGridProps() {
        // The column width is defined so that rows are as full as possible
        // while displaying as many elements per row as reasonable.
        // Be aware that 5 and 10 item sized grids have a 10 columns wide layout
        var desktopColumnSizes = [4, 4, 4, 3, 2, 3, 3, 3, 2];
        var getXs = function () {
            if (options.length <= 4)
                return 6;
            if ([5, 10].includes(options.length))
                return 5;
            return 4;
        };
        return {
            xs: getXs(),
            md: desktopColumnSizes[options.length - 1] || 2,
        };
    }
    function getDefaultContainerGridProps() {
        return {
            columns: [5, 10].includes(options.length) ? 10 : 12,
            gap: 0,
            spacing: 1
        };
    }
    // Deprecate for the time being till adding the support in DRY questions
    // get(gridConfiguration, 'item') ||
    // get(gridConfiguration, 'container') ||
    var gridItemProps = forceUseCustomGrid ? get(gridConfiguration, 'item') : getDefaultItemGridProps();
    var gridContainerProps = forceUseCustomGrid ? get(gridConfiguration, 'container') : getDefaultContainerGridProps();
    var imageOptionsContainerStyles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    };
    var gap = gridContainerProps.gap || 0;
    var styles = avatarOnTopLayout && {
        paddingTop: { xs: 10, md: '0px !important' },
        marginRight: 'auto',
        position: 'relative',
        left: { md: '25px' },
    };
    var defaultStyles = avatarOnTopLayout && {
        paddingTop: { md: '20px !important' },
    };
    var renderedOptions = options.map(function (option, index) { return (_jsxs(Grid, __assign({ item: true }, gridItemProps, { sx: index >= 5 ? styles : defaultStyles, children: [_jsx(Responsive, { maxWidth: theme.breakpoints.xs.max, children: _jsx(SingleImageSelectCard, __assign({ cardStyles: cardStyles || {}, option: mobileOptions[index] || option, isSelected: isSelected(option), onClick: function () { return onClick && onClick(option); }, avatarOnTopLayout: avatarOnTopLayout }, singleImageSelectCardProps), option.value) }), _jsx(Responsive, { minWidth: theme.breakpoints.xs.max, children: _jsx(SingleImageSelectCard, __assign({ cardStyles: cardStyles || {}, option: option, isSelected: isSelected(option), onClick: function () { return onClick && onClick(option); }, avatarOnTopLayout: avatarOnTopLayout }, singleImageSelectCardProps), option.value) })] }), "".concat(questionKey, "-").concat(option.value))); });
    return (_jsx(_Fragment, { children: avatarOnTopLayout ? (_jsx(motion.div, { style: imageOptionsContainerStyles, initial: "hidden", animate: "show", variants: container, children: _jsx(Grid, __assign({ justifyContent: { md: 'center' }, alignItems: 'stretch', width: '100%', container: true, marginLeft: { md: '-48px' }, flexDirection: flexDirection }, gridContainerProps, { gap: { xs: 0, md: gap }, spacing: 1, children: renderedOptions })) })) : (_jsx(motion.div, { style: imageOptionsContainerStyles, initial: "hidden", animate: "show", variants: container, children: _jsx(Grid, __assign({ justifyContent: 'center', alignItems: 'stretch', container: true, flexDirection: flexDirection, columns: 12 }, gridContainerProps, { spacing: 1, children: renderedOptions })) })) }));
};
export default withConditionals(ImageOptions, {
    conditionalValueInArray: {
        arrayPropName: 'options',
        valueKey: 'disabled',
    },
    conditionalArray: {
        arrayPropName: 'options'
    }
});
